import React, { Suspense, useMemo, useState, useEffect, useRef } from 'react'
import Oval from 'react-loading-icons/dist/esm/components/oval';
import { useDispatch, useSelector } from 'react-redux';
import { defer, useLoaderData, useNavigate } from 'react-router-dom';
import { addSitesToGroup, enableUserNotifications, getCompanyUserList, getGroups, getSingleUser, getUserActivity, getUsersDevices, removeUser, switchInstallerMode, getSiteAnalytics } from '../../Api Methods/Api';
import DevicesGrid from '../../components/GridList/DevicesGrid';
import FilterUsersDeviceSearch from '../../components/PowerSearch/FilterUsersDeviceSearch';
import ActivityTableLayout from '../../components/Table/ActivityTableLayout';
import PortalUsersTableLayout from '../../components/Table/PortalUsersTableLayout';
import UserDevicesTableLayout from '../../components/Table/UserDevicesTableLayout';
import SearchBar from '../SearchView/Search/SearchBar';
import PortalActivityPage from '../PortalActivity/PortalActivityPage';
import classes from "./UserDevicesPage.module.css"
import DataManager from '../../hooks/DataManager';
import { serviceActions } from '../../store/service-Slice';
import useSetCookie from '../../../src/components/hooks/UseSetCookie';
import DevicesList from '../../components/GridList/DevicesList';
import DeviceLoadingGrid from '../../components/GridList/DeviceLoadingGrid';
import { da } from 'date-fns/locale';
import Stats2 from '../../components/UI/Stats/Stats2';
import Modal from '../../components/Modal/Modal';
import areYouSureAnim from '../../assets/animations/areYouSure.json'
import loadingAnim from '../../assets/animations/newLoading.json'
import Lottie from 'lottie-react'
import Button1 from '../../components/UI/Button/Button1';
import DropDownForm from '../../components/forms/DropdownCreateGroup';
import SetPhoneNumber from '../../components/Modal/ModalLayouts/SetPhoneNumber';
import UpdateUsername from '../../components/Modal/ModalLayouts/UpdateUsername';
import UpdateEmail from '../../components/Modal/ModalLayouts/UpdateEmail';
import successAnim from '../../assets/animations/success.json'
import failAnim from '../../assets/animations/fail.json'
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { DateRangePicker } from 'rsuite';
import 'rsuite/DateRangePicker/styles/index.css';
import { addDays } from 'date-fns';
import SearchbarSmall from '../../components/UI/Inputs/SearchbarSmall';
import refreshBtn from '../../assets/portalAssets/refreshV2.png';
import ExportExcel from '../../components/ExcelExport/ExcelExport';
import UserActivityTableLayout from '../../components/Table/UserActivityTableLayout';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { EntityHeader } from '../../components/UI/EntityHeader/EntityHeader';
import Divider from '@mui/material/Divider'
import { use } from 'react';

ChartJS.register(ArcElement, Tooltip, Legend);

const UserDevicesPage = () => {

  const dataManager = new DataManager()

  const ModalDialog = useRef();

  localStorage.removeItem('DeviceUUID')

  const HandleShowModal = () => {
    ModalDialog.current.open();
    setChangeNotifications(false)
      setChangePortalAdmin(false)
      setChangePhoneNumber(false)
      setChangeUsername(false)
      setChangeEmailAddress(false)
  };

  const HandleCloseModal = () => {
      ModalDialog.current.close();
      setChangeNotifications(false)
      setChangePortalAdmin(false)
      setChangePhoneNumber(false)
      setChangeUsername(false)
      setChangeEmailAddress(false)
  };

  const GsSkeletonBarChart = () => (
    <div className={classes.chartCard}>
        <div className={classes.skeletonBar} style={{ height: "14px", width: "40%", marginBottom: "16px" }} />
        <div className={classes.skeletonBar} style={{ height: "337px", width: "100%" }} />
    </div>
  );

  const GsSkeletonTableCard = () => (
    <div className={classes.chartCard}>
        <div className={classes.skeletonBar} style={{ height: "18px", width: "30%", marginBottom: "16px" }} />
        <div className={classes.skeletonBar} style={{ height: "200px", width: "100%" }} />
    </div>
  );

  const todayDate = new Date();
  const todayDateString = todayDate.toISOString();

  const thirtyDaysAgoDate = new Date()
  thirtyDaysAgoDate.setDate(thirtyDaysAgoDate.getDate() - 30);
  const thirtyDaysAgoDateString = thirtyDaysAgoDate.toISOString();

  const [modalComponent, setModalComponent] = useState();
  const [modalTitle, setModalTitle] = useState();
  const navigate = useNavigate();
  const [UserDevices, setUserDevices] = useState([]);
  const [userObj, setUserObj] = useState({})
  const [userActivityLog, setUserActivityLog] = useState([])
  const [createdByName, setCreatedByName] = useState("")

  const [pageSize, setPageSize] = useState(100)
  const [pageOffset, setPageOffset] = useState(0)

  

  const dispatch = useDispatch();
  const client = useSelector(state => state.auth.client);
  const token = useSelector(state => state.auth.token);
  const role = useSelector(state => state.auth.role);
  let ClickedUserID = localStorage.getItem('clickedUserID')
  console.log(ClickedUserID);
  const companyName = useSelector(state => state.auth.companyName);

  console.log(localStorage.getItem('ClickedUserID'));
  console.log(localStorage.getItem('clickedUserID'));

  const apiData = { token, client };
  const [update, setUpdate] = useState(0)
  const pageFetchedIndex = dataManager.getItem('pageIndex')
  const [loading, setIsLoading] = useState(true)
  const [isLoadingUser, setIsLoadingUser] = useState(true)
  const [filteredData, setFilteredData] = useState([]);
  const [changeNotifications, setChangeNotifications] = useState(false)
  const [changePortalAdmin, setChangePortalAdmin] = useState(false)
  const [changePhoneNumber, setChangePhoneNumber] = useState(false)
  const [editUserAccess, setEditUserAccess] = useState(false)
  const [sitesForGroupMode, setSitesForGroupMode] = useState(false)
  const [buttonTitle, setButtonTitle] = useState("Remove sites")
  const [addToGroupButtonTitle, setAddToGroupButtonTitle] = useState("Add sites to a group")
  const [sitesToRemove, setSitesToRemove] = useState([]);
  const [sitesForGroup, setSitesForGroup] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("")
  const myUserID = useSelector(state => state.auth.userID)
  const [groups, setGroups] = useState()
  const [selectAllCancelled, setSelectAllCancelled] = useState(false)
  const [showMassSettings, setShowMassSettings] = useState(false)
  const [changeUsername, setChangeUsername] = useState(false)
  const [changeEmailAddress, setChangeEmailAddress] = useState(false)

  const [addToGroupVisible, setAddToGroupVisible] = useState(false)
  const [successVisible, setSuccessVisible] = useState(false)
  const [failVisible, setFailVisible] = useState(false)
  const [confirmVisible, setConfirmVisible] = useState(false)
  const [removeSubUsersDialogVisible, setRemoveSubUsersDialogVisible] = useState(false)

  const [activeTab, setActiveTab] = useState(0);
  const [chartCollapsed, setChartCollapsed] = useState(false);
  const [resetVisible, setResetVisible] = useState();
  const [isLoadingActivity, setIsLoadingActivity] = useState(true);
  const [activitySearchValue, setActivitySearchValue] = useState("");
  const [activityChartData, setActivityChartData] = useState([]);
  const [formattedActivityExportData, setFormattedActivityExportData] = useState([]);
  const [activityDateRange, setActivityDateRange] = useState([
    addDays(new Date(), -30).toISOString(),
    new Date().toISOString()
  ]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [siteData, setSiteData] = useState([]);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [isLoadingBar, setIsLoadingBar] = useState(true);
  const [shouldAnimateChart, setShouldAnimateChart] = useState(true);

const m_names = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];

  const now = new Date();
  now.setDate(now.getDate() + 1);
  const last30 = new Date();
  last30.setDate(now.getDate() - 30);

function formatDate(date) {
  console.log(date);
  const day = date.getDate();
  const sup = [1, 21, 31].includes(day) ? "st"
    : [2, 22].includes(day) ? "nd"
    : [3, 23].includes(day) ? "rd" : "th";
  
  return `${day}${sup} ${m_names[date.getMonth()]} ${date.getFullYear()}`;
}

  useEffect(() => {
      GetSingleUser()
      GetUserActivity()
  }, [])

  const GetSingleUser = async () => {
    console.log(ClickedUserID)
    try {
      const response = await getSingleUser(apiData, ClickedUserID, dispatch)
      const user = response.data[0][0]
      console.log(user);
      if (user) {
        setUserObj(user)

        if (user.createdBy != null) {
          console.log(user.createdBy);
          //setCreatedByName(user.createdBy ?? "Unknown")
          GetCreatedUser(user.createdBy)
        }
      }
    } finally {
      setIsLoadingUser(false)
    }
  }

  const GetCreatedUser = async (userID) => {
    const response = await getSingleUser(apiData, userID, dispatch)
    console.log(response.data);
    setCreatedByName(response.data[0][0].fullName ?? "")

    console.log(response.data[0].fullName);
  }

  const GetUserActivity = async (overrides = {}) => {
    setIsLoadingActivity(true);

    const size = overrides.pageSize ?? pageSize;
    const offset = overrides.pageOffset ?? pageOffset;

    let body = {
      "userID": ClickedUserID,
      "pageSize": size,
      "pageOffset": offset,
      "startDate": activityDateRange[0],
      "endDate": activityDateRange[1]
    }

    console.log(body);

    const response = await getUserActivity(apiData, body, dispatch)
    setUserActivityLog(response.data[0].events)
    setActivityChartData(response.data[0].count ?? [])
    setIsLoadingActivity(false);

    console.log(response.data[0].count);
  }

  const portalAccess = userObj?.portalAccess == null || userObj?.portalAccess == "" || userObj?.portalAccess == '' ? "No" : "Yes"
  const portalGroup = userObj?.portalGroupName
  const notifications = userObj?.notifications == "yes" ? "Enabled" : "Disabled"
  const lastLoggedInDate = userObj?.lastLoggedIn ? new Date(userObj.lastLoggedIn) : null
  const userSinceDate = userObj?.created ? new Date(userObj.created) : null
  const phoneNumber = userObj?.phoneNumber == '0' ? "Not provided" : userObj?.phoneNumber
  const userName = userObj?.fullName
  const formattedLastLoggedIn = lastLoggedInDate
    ? lastLoggedInDate.toLocaleString(undefined, { day: "numeric", month: "long", year: "numeric" })
    : "Never";
  const formattedUserSinceDate = userSinceDate
    ? userSinceDate.toLocaleString(undefined, { day: "numeric", month: "long", year: "numeric" })
    : null;
  const userEmail = userObj?.email

  const handlePageSizeChange = (newSize) => {
    setPageSize(newSize);
    setPageOffset(0);
    GetUserActivity({ pageSize: newSize, pageOffset: 0 });
  }

  const handleNextPage = () => {
    const newOffset = pageOffset + pageSize;
    setPageOffset(newOffset);
    GetUserActivity({ pageOffset: newOffset });
  }

  const handlePrevPage = () => {
    const newOffset = Math.max(0, pageOffset - pageSize);
    setPageOffset(newOffset);
    GetUserActivity({ pageOffset: newOffset });
  }

  useEffect(() => {
    console.log(selectedDate);
    if (selectedDate != null){
      const filteredLogToDate = userActivityLog.filter(event => new Date(event.eventDate).toISOString().split('T')[0] === selectedDate)
      setUserActivityLog(filteredLogToDate)
      setChartCollapsed(true)
    }
  }, [selectedDate])
  const apiDataRef = useRef({ token, client, companyName });
  apiDataRef.current = { token, client, companyName };

  let origin = null
  console.log(userObj);

  switch (userObj?.origin){
    case "created":
      origin = `Created by ${createdByName}`
      break;
    case "invited":
      origin = `Invited by ${createdByName}`
      break;
    case "self": 
      origin = "Registered via app"
      break;
  }

  const HandleUsersDevices = async () => {
    const data = await getUsersDevices(apiData, ClickedUserID, companyName, dispatch)
    dataManager.setItem('existingSites', []);
    setFilteredData(data)
    setUserDevices(data)
    setIsLoading(false)
  }

  const GetGroups = async () => {
    const response = await getGroups(apiData, dispatch);
    setGroups(response)
  }

  useEffect(() => {
    GetGroups();
    HandleUsersDevices();
  }, []);


  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
      setPageOffset(0);
      GetUserActivity({ pageOffset: 0 });
  }, [activityDateRange])

  useEffect(() => {
    const handleDeviceFilter = () => {
      const filtered = UserDevices.filter((item) =>
        Object.values(item)
          .some((value) => value?.toString().toLowerCase().includes(searchQuery.toLowerCase()))
      );
      dataManager.setItem('userSitesSearchTerm', searchQuery); 
      setFilteredData(filtered); 
    };
  
    if (searchQuery !== dataManager.getItem('userSitesSearchTerm')) {
      handleDeviceFilter(); 
    }
  }, [searchQuery]);

  const HandleEditUser = async (task) => {
    switch (task){
      case 'notification' :
        //pertform change NC API
        let newState = userObj.notifications == 'yes' ? "no" : "yes"
        const responseData = await enableUserNotifications(apiData, userObj.id, newState, dispatch)
        if (responseData) {
          const newStateFormatted = newState == "yes" ? "enabled" : "disabled"
          setUserObj((prevUserObj) => ({
            ...prevUserObj,
            notifications: newState,
          }));
          HandleCloseModal();
          setChangeNotifications(false)
          successModal(`Successfully ${newStateFormatted} notifications for ${userObj.fullName}`)
        } else {
          HandleCloseModal();
          setChangeNotifications(false)
          errorModal(`Failed to update notifications for ${userObj.fullName}`)
        }
        
      break;
      case 'portalAdmin':
        //perform change installer API
        const newValue = userObj.portalAccess !== "" ? "" : "INSTALLER"
        const response = await switchInstallerMode(apiData, userObj.id, newValue)
        if (response) {
          const newValueFormatted = newValue == "" ? "revoked" : "granted"
            //modify userObj to update installer value
          setUserObj((prevUserObj) => ({
            ...prevUserObj,
            portalAccess: newValue,
          }));

          HandleCloseModal();
          setChangePortalAdmin(false)
          successModal(`Successfully ${newValueFormatted} app admin privilages for ${userObj.fullName}`)
        } else {
          HandleCloseModal()
          setChangePortalAdmin(false)
          errorModal(`Failed to update app admin privilages for ${userObj.fullName}`)
        }
        
      break;
    }
  }

  const confirmModal = (message, task) => {
      setModalTitle("Confirm")
      setModalComponent(
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <Lottie animationData={areYouSureAnim} loop={false} style={{ width: 150, height: 150, margin: "0px" }} />
          <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>{message}</h3>
          <br></br>
          <Button icon="pi pi-check" onClick={() => HandleEditUser(task)} label="Confirm" severity='success'/>
          <br></br>
          <Button icon="pi pi-times" onClick={HandleCloseModal} label="Cancel" severity='secondary'/>
        </div>
      )
      HandleShowModal();
  }

  const successModal = (message) => {
    setModalTitle('Success')
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <Lottie animationData={successAnim} loop={false} style={{ width: 250, height: 250, margin: "0px" }} />
        <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>{message}</h3>
        <br></br>
        <Button icon="pi pi-times" onClick={HandleCloseModal} label='Close' severity='secondary'/>
      </div>
    )
    HandleShowModal();
  }

  const errorModal = (message) => {
    setModalTitle('Error')
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <Lottie animationData={failAnim} loop={false} style={{ width: 150, height: 150, margin: "0px" }} />
        <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>{message}</h3>
        <br></br>
        <Button icon="pi pi-times" onClick={HandleCloseModal} label="Close" severity='secondary'/>
        
      </div>
    )
    HandleShowModal();
  }

  useEffect(() => {
    if (changeNotifications){
      const newValue = userObj.notifications == 'no' ? "enable" : "disable"
      confirmModal(`Are you sure you want to ${newValue} notifications for ${userObj.fullName}?`, "notification");
    }
    
  }, [changeNotifications])

  useEffect(() => {
    if (changePortalAdmin){
      //TODO - Bug here, needs 2 presses
      const newValue = userObj.portalAccess !== "" && userObj.portalAccess !== null ? "revoke" : "grant"
      confirmModal(`Are you sure you want to ${newValue} app admin privilages for ${userObj.fullName}?`, "portalAdmin");
    }
  }, [changePortalAdmin])

  useEffect(() => {
    if (changePhoneNumber){
      //showpopup
      setModalTitle("Edit phone number")
      setModalComponent(
        <SetPhoneNumber 
          placeholder={phoneNumber}
          successModal={successModal}
          errorModal={errorModal}
          HandleCloseModal={HandleCloseModal}
          HandleShowModal={HandleShowModal}
          userObject={userObj}
          setUserObject={setUserObj}
        />
      )

      HandleShowModal();
    }
    
  }, [changePhoneNumber])


  useEffect(() => {
    if (changeUsername) {
      setModalTitle("Change name")
      setModalComponent(
        <UpdateUsername
          placeholder={userName}
          successModal={successModal}
          errorModal={errorModal}
          HandleCloseModal={HandleCloseModal}
          HandleShowModal={HandleShowModal}
          userObject={userObj}
          setUserObject={setUserObj}
        />
      )
      HandleShowModal();
    }
  }, [changeUsername])


  useEffect(() => {
    if (changeEmailAddress) {
      setModalTitle("Change email address")
      setModalComponent(
        <UpdateEmail
          placeholder={userEmail}
          successModal={successModal}
          errorModal={errorModal}
          HandleCloseModal={HandleCloseModal}
          HandleShowModal={HandleShowModal}
          userObject={userObj}
          setUserObject={setUserObj}
        />
      )
      HandleShowModal();
    }
  }, [changeEmailAddress])

  useEffect(() => {
  }, [sitesToRemove])

  useEffect(() => {
  }, [sitesForGroup])

  useEffect(() => {
    if (activeTab !== 2) return;

    const bothNull = !selectedStartDate && !selectedEndDate;
    const bothSet = selectedStartDate && selectedEndDate;
    if (!bothNull && !bothSet) return; 

    setSiteData([])

    const GetTopSites = async () => {
      setIsLoadingBar(true);
      setShouldAnimateChart(true);
      const endDatePlusOne = bothSet ? addDays(new Date(selectedEndDate), 2) : now;
      const response = await getSiteAnalytics(apiDataRef.current, {
        userID: parseInt(ClickedUserID),
        groupName: dataManager.getItem('selectedGroup') || companyName,
        start_date: bothSet ? selectedStartDate : last30,
        end_date: endDatePlusOne,
        analyticsType: "usersPerSite"
      }, dispatch);
      setSiteData(response?.data?.[0]?.usersPerSiteStats || [])
      setIsLoadingBar(false);
    }
    GetTopSites();
  }, [activeTab, selectedStartDate, selectedEndDate])

  const sixMonthsAgo = new Date();
  sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
  const disableActivityDates = (date) => date < sixMonthsAgo || date > new Date();

  const customActivityShortcuts = [
    { label: 'Yesterday', value: [addDays(new Date(), -1), new Date()] },
    { label: 'Last 7 Days', value: [addDays(new Date(), -7), new Date()] },
    { label: 'Last 30 Days', value: [addDays(new Date(), -30), new Date()] },
    { label: 'This Month', value: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()] }
  ];

  const handleActivityDateOk = (value) => {
    setActivityDateRange([value[0].toISOString(), value[1].toISOString()]);
  };

  const handleActivityShortcutClick = (shortcut) => {
    setActivityDateRange([shortcut.value[0].toISOString(), shortcut.value[1].toISOString()]);
  };
  
  const editUserSiteAccess = () => {
    setButtonTitle(!editUserAccess ? "Cancel" : "Remove sites")
    setEditUserAccess(!editUserAccess);

    if (buttonTitle == "Cancel"){
      setSitesToRemove([])
      dataManager.setItem('existingSites', [])
      setSelectAllCancelled(true)
    }
  }

  const HandleRevokeAccess = async (includeSubUsers) => {
    pleaseWaitModal(sitesToRemove.length);
    if (sitesToRemove.length > 0){
      for (const site of sitesToRemove) {
        const { deviceUUID, deviceID } = site;
        const success = await removeUser(apiData, deviceID, deviceUUID, myUserID, userObj.id, includeSubUsers, dispatch);
    
        if (success) {
          setFilteredData(prevFilteredData => prevFilteredData.filter(site => site.deviceUUID !== deviceUUID));
        } else {
        }
      }
      HandleCloseModal();
      setEditUserAccess(false)
      setButtonTitle("Remove sites")
      successModal(`${userObj.fullName}'s access successfully revoked from ${sitesToRemove.length} site(s)`)
      HandleUsersDevices()
      setSitesToRemove([])
    } else {
      errorModal("Please select a site")
    }
  }

  const HandleGiveAccess = () => {
    //dataManager.setItem('isGroupMode', true);
    dataManager.setItem('isAddAccessMode', true)
    dataManager.setItem('existingSites', UserDevices)
    navigate('/Dashboard/AllSites/');
  }

  const pleaseWaitModal= (siteCount) => {
    setModalTitle("Please wait")
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <Lottie animationData={loadingAnim} loop={true} style={{ width: 250, height: 250, margin: "0px" }} />
        <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>{`Revoking ${userObj.fullName}'s access from ${siteCount} site(s)`}</h3>
      </div>
    )
    HandleShowModal();
  }

  const waitModal= (siteCount, groupName) => {
    setModalTitle("Please wait")
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <Lottie animationData={loadingAnim} loop={true} style={{ width: 250, height: 250, margin: "0px" }} />
        <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>{`Adding ${siteCount} sites to ${groupName}`}</h3>
      </div>
    )
    HandleShowModal();
  }


  const HandleAddSitesForGroup = () => {
    setAddToGroupButtonTitle(!sitesForGroupMode ? "Cancel" : "Add sites to a group")
    setSitesForGroupMode(!sitesForGroupMode);

    if (addToGroupButtonTitle == "Cancel"){
      setSitesForGroup([])
      setSelectAllCancelled(true)
    }
  }

  const HandleUipiodOnClick = (DeviceUUID) => {
    dispatch(serviceActions.setDeviceUUID(DeviceUUID));
    useSetCookie("DeviceUUID", DeviceUUID, 1);
    navigate("/Dashboard/SiteView/" + DeviceUUID);
  }

  const ShowSelectGroup = async () => {
    if (sitesForGroup.length > 0){
      const allGroups = await getGroups(apiData, dispatch);
      const groupNames = allGroups.map(listOptions => listOptions.name).sort((a, b) => a.localeCompare(b));;
          setModalTitle("Add site to group")
          setModalComponent(
            <div>
              <DropDownForm label={"Please select a group below"} dropDownOptions={groupNames} setSelectedGroup={setSelectedGroup} />
              <br></br>
              <Button icon="pi pi-plus" onClick={() => AddSitesToGroup(allGroups)} label="Add to group" severity='success'/>
              
            </div>
            
          )
          HandleShowModal();
    } else {
      errorModal("Please select a site")
    }
  }

  const AddSitesToGroup = async () => {
    if (sitesForGroup.length > 0) {

      let body = {
        groupID: selectedGroup.id,
        groupName: selectedGroup.name,
        groupDevices: sitesForGroup,
      }

      const response = await addSitesToGroup(apiData, body, dispatch)
      if (response.success){
        //HandleCloseModal();
        setAddToGroupVisible(false)
        waitModal(sitesForGroup.length, dataManager.getItem('selectedGroup'))
        successModal(`${sitesForGroup.length} sites successfully added to ${selectedGroup.name}`, false);
        setSitesForGroupMode(false)
        setSitesForGroup([])
        setAddToGroupButtonTitle("Add sites to a group")
        HandleUsersDevices()
      } else {
      }
    } else {
      errorModal("Please select a site");
    }
  }

const rawLabels = activityChartData.map((d) => d.eventDay.split('T')[0]);
const labels = rawLabels.map((d) => formatDate(new Date(d)));
const values = activityChartData.map((d) => d.eventCount);

const chartOptions = {
  responsive: true,
  plugins: {
    legend: { display: false },
  },
  scales: {
    x: {
      grid: { display: false },
      border: { display: false },
    },
    y: {
      grid: { display: false },
      border: { display: false },
      ticks: {
        precision: 0,
      },
    },
  },
  onClick: (event, elements) => {
    if (!elements.length) return;

    const index = elements[0].index;
    setSelectedDate(rawLabels[index]); // raw ISO date, safe for filtering
  },
};

const chartData = {
  labels,
  datasets: [
    {
      label: 'Events per day',
      data: values,
      backgroundColor: 'rgba(54, 162, 235, 0.6)',
      borderRadius: 8,           
      borderSkipped: false,   
    },
  ],
};

const resetFilters = async () => {
  setPageOffset(0);
  await GetUserActivity({ pageOffset: 0 })
  setChartCollapsed(false)
  setSelectedDate(null)
}

const formatEventDate = (dateStr, period) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    

    switch (period) {
    case '7D':
        return date.toLocaleDateString('en-US', { weekday: 'short' });
    case '1M':
        return `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    case '3M':
        return date.toLocaleDateString('en-US', { month: 'short' });
    case 'standard':
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    default:
        return dateStr;
    }
};

const BarCard = ({ title, labels, values, colors, datasets, siteData, isLoadingBar, shouldAnimate, onAnimationComplete }) => {
  const data = {
        labels,
        datasets: datasets || [{ label: "", data: values, backgroundColor: colors, borderWidth: 0, borderRadius: 4 }],
    };
  const legendColors = ['rgba(54, 162, 235, 0.6)', 'rgba(75, 192, 192, 0.6)'];
  return (
    <div className={classes.chartCard}>
      <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", marginBottom: "18px"}}>
        <p className={classes.chartTitle}>{title}</p>
            <div style={{ display: "flex", gap: "14px", alignItems: "center", marginLeft: "auto" }}>
                <Calendar style={{ height: '38px' }}inputId="start_date" value={selectedStartDate} onChange={(e) => setSelectedStartDate(e.value)} dateFormat="yy-mm-dd" placeholder="From" />
                <span>—</span>
                <Calendar style={{ height: '38px' }} inputId="end_date" value={selectedEndDate} onChange={(e) => setSelectedEndDate(e.value)} dateFormat="yy-mm-dd" placeholder="To" />
                <span
                    className={`${classes.clearText} ${(selectedStartDate || selectedEndDate) ? classes.clearTextActive : ''}`}
                    onClick={() => {
                        if (selectedStartDate || selectedEndDate) {
                            setSelectedStartDate(null);
                            setSelectedEndDate(null);
                        }
                    }}>
                    Clear
                </span>
            </div>
      </div>
      {isLoadingBar ? <GsSkeletonBarChart /> : siteData && siteData.length > 0 ? (
      <>
      <div className={classes.userLegend}>
          {siteData.slice(0,10).map((item, index) => (
              <div
                  key={item.siteName}
                  className={classes.userLegendItem}
                  onClick={() => {HandleUipiodOnClick(item.siteID)}}
                  //style={{ cursor: item.userID != null && onUserClick ? 'pointer' : 'default' }}
              >
                  <span
                      className={classes.userLegendDot}
                      style={{ backgroundColor: legendColors[index % legendColors.length] }}
                  />
                  <span>{item.siteName || item.siteKey}</span>
              </div>
          ))}
      </div>

        <div className={classes.barContainer} style={{ height: "300px" }}>
            <Bar data={data} options={{ indexAxis: 'y', responsive: true, maintainAspectRatio: false, animation: shouldAnimate ? { onComplete: onAnimationComplete } : false, plugins: { legend: { display: false }, tooltip: { enabled: true } }, scales: { x: { beginAtZero: true, ticks: { stepSize: 1 } }, y: { grid: { display: false }, ticks: { autoSkip: false } } } }} />
        </div>
      </>
      ) : (
        <p style={{ textAlign: "center", color: "#888888", marginTop: "2rem" }}>No user activity data available for this time period.</p>
      )}

    </div>
    );
}


  return (  
    <>
    <Modal ref={ModalDialog} title={modalTitle} modalName={""} HandleShowModal={HandleShowModal}>
          {modalComponent}
    </Modal>

    {/* Temporarily disabled until backend supports includeSubUsers */}
    {false && (
    <Dialog
        header="Remove user"
        visible={removeSubUsersDialogVisible}
        style={{ width: "420px" }}
        onHide={() => setRemoveSubUsersDialogVisible(false)}
    >
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <p style={{ margin: 0, color: "#4a4a4a", fontSize: "14px" }}>Would you also like to remove users that this person invited to these sites?</p>
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <Button
                    label="Remove user only"
                    icon="pi pi-user-minus"
                    severity="danger"
                    outlined
                    onClick={() => { setRemoveSubUsersDialogVisible(false); HandleRevokeAccess(false); }}
                />
                <Button
                    label="Remove user and their invited users"
                    icon="pi pi-users"
                    severity="danger"
                    onClick={() => { setRemoveSubUsersDialogVisible(false); HandleRevokeAccess(true); }}
                />
            </div>
            <Button label="Cancel" icon="pi pi-times" severity="secondary" onClick={() => setRemoveSubUsersDialogVisible(false)} />
        </div>
    </Dialog>
    )}

    <Dialog
        header="Add to group"
        visible={addToGroupVisible}
        style={{ width: "40vw" }}
        onHide={() => setAddToGroupVisible(false)}
        >
        <div>
            <p>Choose the new group from the dropdown below</p>
            <Dropdown
                value={selectedGroup}
                className="w-full md:w-14rem"
                style={{ width: '400px' }}
                onChange={(e) => setSelectedGroup(e.value)}
                options={groups}
                optionLabel="name"
                placeholder="Choose group"
                showClear
                filter
                filterPlaceholder="Search groups..."
            />


        </div>

        <br></br>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button label="Add sites to group" severity="success" icon="pi pi-plus" disabled={!selectedGroup} onClick={AddSitesToGroup} />
        </div>
    </Dialog>
    

          <EntityHeader
            titlePart1={userObj?.fullName || userObj?.email}
            iconText={formattedUserSinceDate && `User since ${formattedUserSinceDate}`}
            secondaryText={formattedLastLoggedIn != "Never" && `Last logged in ${formattedLastLoggedIn}`}
          />

          <Divider style={{ marginTop: '20px', marginBottom: '20px', width: '100%' }} />

          <div className={classes.container}>
            <Stats2 title={"Name"} value={userObj?.fullName}  isLoadingStats={isLoadingUser} isStatic={true} setChangeUsername={setChangeUsername} editable={role === "admin" || role === "TechSupport"}/>
            <Stats2 title={"Email address"} value={userObj?.email}  isLoadingStats={isLoadingUser} isStatic={true} setChangeEmailAddress={setChangeEmailAddress} editable={role === "admin" || role === "TechSupport"}/>
            <Stats2 title={"Phone number"} value={phoneNumber}  isLoadingStats={isLoadingUser} isStatic={true} setChangePhoneNumber={setChangePhoneNumber} editable={role === "admin" || role === "TechSupport"}/>
            <Stats2 title={"User since"} value={formattedUserSinceDate}  isLoadingStats={isLoadingUser} isStatic={true} />
            <Stats2 title={"Last logged in"} value={formattedLastLoggedIn}  isLoadingStats={isLoadingUser} isStatic={true} />
            {!isLoadingUser && userObj?.type && <Stats2 title={"Device type"} value={userObj.type}  isLoadingStats={false} isStatic={true} />}
            {!isLoadingUser && origin && <Stats2 title={"Origin"} value={origin}  isLoadingStats={false} isStatic={true} /> }
            <Stats2 title={"Total access"} value={filteredData.length}  isLoadingStats={isLoadingUser} isStatic={true} />
            <Stats2 title={"Notifications"} value={notifications}  isLoadingStats={isLoadingUser} isStatic={true} changeNotifications={changeNotifications} setChangeNotifications={setChangeNotifications} editable={role === "admin" || role === "TechSupport"}/>
            <Stats2 title={"App admin"} value={portalAccess}  isLoadingStats={isLoadingUser} isStatic={true} changePortalAdmin={changePortalAdmin} setChangePortalAdmin={setChangePortalAdmin} editable={role === "admin" || role === "TechSupport"}/>
            {/* {portalGroup !== null && <Stats2 title={"Portal group"} value={portalGroup}  isLoadingStats={isLoadingUser} isStatic={true} changePortalAdmin={changePortalAdmin} setChangePortalAdmin={setChangePortalAdmin} editable={role === "admin" || role === "TechSupport"}/>} */}


          </div>

          <div className={classes.tabsWrapper}>
            <div className={classes.tabs}>
              {["Sites", "Activity", /*"Insights"*/].map((tab, i) => (
                <button
                  key={tab}
                  className={`${classes.tab} ${activeTab === i ? classes.active : ""}`}
                  onClick={() => setActiveTab(i)}
                >
                  {tab}
                </button>
              ))}
            </div>

            <div className={classes.tabContent}>
              {activeTab === 1 && (
                <>
                  <div className={classes.activityTop}>
                    <div className={classes.activityControls}>
                      <SearchBar
                        placeholder="Search events"
                        value={activitySearchValue}
                        onChange={(e) => setActivitySearchValue(e.target.value)}
                      />
                      {(selectedDate == null) && <DateRangePicker
                        style={{ display: 'flex', border: "1.5px solid #c4c4c4", borderRadius: "10px", padding: "1px" }}
                        format="dd.MM.yyyy"
                        onOk={handleActivityDateOk}
                        onShortcutClick={handleActivityShortcutClick}
                        shouldDisableDate={disableActivityDates}
                        calendarSnapping={true}
                        appearance='subtle'
                        cleanable={false}
                        ranges={customActivityShortcuts}
                        value={[new Date(activityDateRange[0]), new Date(activityDateRange[1])]}
                      />}
                      { selectedDate == null && <img className={classes.refreshButton} onClick={GetUserActivity} src={refreshBtn} alt="Refresh" />}
                      { selectedDate && <Button onClick={resetFilters} label='Reset' outlined severity='danger'/>}

                    </div>
                    <ExportExcel
                      style={{ height: "40px", width: '150px' }}
                      excelData={formattedActivityExportData}
                      fileName={"Activity For: " + userObj.fullName}
                      title={"Portal - Activity: " + userObj.fullName}
                      colWidths={[{ wch: 40 }, { wch: 40 }, { wch: 40 }]}
                    />
                  </div>
                  {activityChartData.length >= 2 && <div className={classes.chartRow}>
                   <div className={`${classes.chartPanel} ${chartCollapsed ? classes.chartPanelCollapsed : ''}`}>
                      <Bar 
                        data={chartData} 
                        options={chartOptions} 
                      />
                    </div>
                    <button
                      className={classes.chartCollapseButton}
                      onClick={() => setChartCollapsed(c => !c)}
                      title={chartCollapsed ? "Show chart" : "Hide chart"}
                    >
                      {chartCollapsed ? '▼' : '▲'}
                    </button>
                  </div>}

                  <div>
                    {selectedDate && <h3 style={{ fontWeight: "600", color: "#6e6e6e", margin: "0px", marginBottom: "15px" }}>Viewing {formatDate(new Date(selectedDate))}</h3>}
                  </div>
                  
                  <UserActivityTableLayout
                    data={userActivityLog}
                    isloading={isLoadingActivity}
                    setExportData={setFormattedActivityExportData}
                    userFullName={userName}
                    groups={groups}
                    activityDateRange={activityDateRange}
                    filtering={activitySearchValue}
                    pageSize={pageSize}
                    pageOffset={pageOffset}
                    onPageSizeChange={handlePageSizeChange}
                    onNextPage={handleNextPage}
                    onPrevPage={handlePrevPage}
                  />
                </>
              )}

              {activeTab === 2 && (
                <>
                <BarCard
                  title="Frequently Accessed Sites"
                  labels={siteData.slice(0,10).map(s => s.siteName || s.siteKey)}
                  values={siteData.slice(0,10).map(s => s.actions)}
                  siteData={siteData}
                  colors={['rgba(54, 162, 235, 0.6)', 'rgba(75, 192, 192, 0.6)']}
                  isLoadingBar={isLoadingBar}
                  shouldAnimate={shouldAnimateChart}
                  onAnimationComplete={() => setShouldAnimateChart(false)}
                />

                < br/>
                {isLoadingBar ? (
                  <GsSkeletonTableCard />
                ) : (
                siteData.length > 10 && (
                <div className={classes.chartCard}>
                  <p className={classes.chartTitle}>Top 20 Accessed Sites</p>
                  <DataTable value={siteData} showGridlines={true} rows={20} removableSort dataKey="siteId" emptyMessage="No sites available" >
                    <Column
                      field="siteKey"
                      header="Site ID"
                      style={{ minWidth: "8rem" }}
                      body={(rowData) => (
                          <span
                              className={classes.tableUser}
                              onClick={() => {HandleUipiodOnClick(rowData.siteID)}}>
                              {rowData.siteKey}
                          </span>
                      )}
                    />
                    <Column field="siteName" header="Name" style={{ minWidth: "12rem" }} body={(rowData) => rowData.siteName || "[No Name Set]"} />
                    <Column field="actions" header="Total Actions" sortable style={{ minWidth: "8rem" }} />
                    <Column field="latest_action" header="Latest Action" sortable style={{ minWidth: "12rem" }} body={(rowData) => formatEventDate(rowData.latest_action, "standard")} />
                  </DataTable>
                </div>
                )
                )}
              </>
              )}

              {activeTab === 0 && (
                loading ? (
                  <div style={{ display: "flex", width: "100%" }}>
                    <DeviceLoadingGrid CardCount={20} />
                  </div>
                ) : (
                  <div style={{ width: "100%" }}>
                    <div className={classes.searchContainer}>
                      <SearchBar
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{
                          padding: "10px",
                          width: "200px",
                          fontSize: "14px",
                          boxSizing: "border-box",
                          borderRadius: "4px",
                        }}
                      />

                      {/* Buttons wrapper */}
                      <div style={{ display: "flex", gap: "10px", marginLeft: "20px" }}>
                        {(role === "admin" || role === "TechSupport") && (!sitesForGroupMode && !editUserAccess) && (
                          <Button
                            label='Add sites'
                            icon="pi pi-plus"
                            severity='success'
                            style={{ padding: 10, fontSize: "14px" }}
                            onClick={HandleGiveAccess}
                          />
                        )}

                        {(role === "admin" || role === "TechSupport") && !sitesForGroupMode && (
                          <Button
                            label={buttonTitle}
                            icon="pi pi-times"
                            severity='danger'
                            style={{ padding: 10, fontSize: "14px" }}
                            onClick={editUserSiteAccess}
                          />
                        )}

                        {(role === "admin" || role === "TechSupport") && !editUserAccess && (
                          <Button
                            label={addToGroupButtonTitle}
                            icon={addToGroupButtonTitle == "Cancel" ? "pi pi-times" : "pi pi-plus"}
                            severity={addToGroupButtonTitle == "Cancel" ? 'danger' : 'info'}
                            style={{ padding: 10, fontSize: "14px" }}
                            onClick={HandleAddSitesForGroup}
                          />
                        )}

                        {(!editUserAccess && sitesForGroupMode) && (
                          <Button
                            label='Add to group'
                            icon="pi pi-plus"
                            severity='success'
                            style={{ padding: 10, fontSize: "14px" }}
                            onClick={() => setAddToGroupVisible(true)}
                          />
                        )}

                        {(editUserAccess && !sitesForGroupMode) && (
                          <Button
                            label='Revoke access'
                            icon="pi pi-ban"
                            severity='danger'
                            style={{ padding: 10, fontSize: "14px" }}
                            // Temporarily disabled until backend supports includeSubUsers - revoke access directly as before
                            // onClick={() => setRemoveSubUsersDialogVisible(true)}
                            onClick={() => HandleRevokeAccess(false)}
                          />
                        )}
                      </div>
                    </div>

                    {searchQuery !== "" && (
                      <div>
                        <p>{filteredData.length} results</p>
                      </div>
                    )}

                    <DevicesList
                      devices={filteredData}
                      filtering={""}
                      pageFetchedIndex={1}
                      isUsersSites={true}
                      groupMode={false}
                      update={update}
                      setUpdate={setUpdate}
                      hideControls={true}
                      isSortable={true}
                      editUserAccess={editUserAccess}
                      sitesForGroup={sitesForGroup}
                      setSitesForGroup={setSitesForGroup}
                      sitesForGroupMode={sitesForGroupMode}
                      setSitesForGroupMode={setSitesForGroupMode}
                      sitesToRemove={sitesToRemove}
                      setSitesToRemove={setSitesToRemove}
                      HandleGiveAccess={HandleGiveAccess}
                      selectAllCancelled={selectAllCancelled}
                      showMassSelect={false}
                      showMassSettings={showMassSettings}
                      setShowMassSettings={setShowMassSettings}
                    />
                  </div>
                )
              )}
            </div>
          </div>
        </>
  )
}

export default UserDevicesPage

export async function loader() {
  const token = localStorage.getItem('token');
  const client = localStorage.getItem('client');
  const companyName = localStorage.getItem('companyName');
  const userID = localStorage.getItem('ClickedUserID');

  const apiData = {
    token,
    client
  }

  return defer({
    //userDevices: getUsersDevices(apiData, userID, companyName)
  })
}
